import {React} from '@api'

export * from './VipLocalStore'
export * from './common'
export * from './enums' // moved from utils
export * from '../resources'
export * from './c8'
export * from './admin'
export * from './catalog'
export * from './CatalogItemDetails' // Was lazy loaded but too much pain
export * from './dashboard'
export * from './dev'
export * from './drawer'
export * from './errors'
export * from './landingScreen'
export * from './libraries'
export * from './logout'
export * from './modal'
export * from './pages'
// export * from './pdf'
export * from './siteHeader'
export * from './notifications'
export * from './catalogSearcher'
export * from './contextMenus'
export * from './workspaces'
export * from './syncIndicator'
export * from './jira'
export * from './changelog'
export * from './titleBarItem'
export {IFlexLayoutWhiteboardTabConfigSettings, NewWhiteboardTabMenuItem, WhiteboardFlexLayoutTab, IFlexLayoutWhiteboardTabConfig} from './whiteboard'

export const Login = React.lazy(() => import(/* webpackChunkName: "login" */ './login').then(m => ({default: m.Login})))



// WEBPACK FOOTER //
// ./src/modules/index.ts